import { DeleteDialog } from "components";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  freeFieldDefinitionId: number
}

const FreeFieldDefinitionOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.FreeFieldDefinition.Delete({
      freeFieldDefinitionId: props.freeFieldDefinitionId
    });
    window.location.href = props.listUrl;
  };

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: true,
        }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.FreeField.DeleteFreeFieldConfirm}
    />
  </>;
};

export default FreeFieldDefinitionOptionsPanel;